export default ({
    apiUrl: "https://api.dandelionpj.com/",
})